<div class="background sb-router-outlet__no-header pb-5">
  <div class="container text-center pt-3">
    <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/logo-springbot-send.svg" class="sb-logo pt-5">
    <h1 class="my-5">
      Forgot your password?
    </h1>
    <p class="subheader w-75 m-auto mt-3 medium-gray-color">
      No problem, it happens all the time. Tell us the email address associated with your account, and we will send you some instructions to reset your password.
    </p>

    <div class="text-left register-form-container mt-5" *ngIf="!resetSuccess">
      <div class="alert alert-danger" [innerHTML]="error" *ngIf="!!error"></div>
      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="field">
          <label class="form-label">Email address</label><br>
          <input class="form-control" name="email" [ngClass]="{ 'is-invalid' : email.errors && (email.dirty || email.touched) }"
                 formControlName="email" type="email" required placeholder="The email you use to log in">
          <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
            <span *ngIf="email.errors.required">
              Required
            </span>
            <span *ngIf="email.errors.email">
              Email address is invalid
            </span>
          </div>
        </div>

        <button class="btn btn-success w-100 mt-2">Reset password</button>
      </form>
    </div>

    <div class="text-center register-form-container card mt-5 p-4 border-0" *ngIf="resetSuccess">
      <fa-icon [icon]="['fas', 'envelope-open-text']" size="3x" class="primary-blue-color m-auto"></fa-icon>
      <h2 class="mt-5 mb-3">
        Password Reset
      </h2>
      <p>Almost there!</p>
      <div>
        Now just click the verification link in the email sent to
        <b>
          {{ email.value }}
        </b>
      </div>
      <p class="medium-gray-color mt-5 more-info-container" (click)="collapse.toggle()">
        I didn't receive the email
        <fa-icon [icon]="['fas', 'chevron-up']" size="1x" *ngIf="!moreInfo" class="primary-blue-color pl-2"></fa-icon>
        <fa-icon [icon]="['fas', 'chevron-down']" size="1x" *ngIf="moreInfo" class="primary-blue-color pl-2"></fa-icon>
      </p>

      <div #collapse="ngbCollapse" [(ngbCollapse)]="moreInfo">
        <div class="mx-5">
          <div class="text-left">
            <ul>
              <li type="disc">
                <button type="button" class="btn btn-link p-0 more-info-buttons" (click)="changeEmail()">
                  Change my email address
                </button>
              </li>
              <li type="disc">
                <button type="button" class="btn btn-link p-0 more-info-buttons" [disabled]="emailSent" (click)="resendEmail()">
                  Resend the email
                </button>
                <span *ngIf="emailSent">. Sent <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="primary-green-color"></fa-icon></span>
              </li>
              <li type="disc">
                Search your inbox and spam/junk folders for an email from
                <strong>support@springbot.com</strong></li>

              <li type="disc">
                Look for an email with the subject line "<strong>Welcome to Springbot!"</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
